import { Button, Grid } from "@mui/material";

type DrawerButtonProps = {
  onClick: () => void;
  name: string;
  disabled?: boolean;
};
const DrawerFooterButton = ({ onClick, name, disabled = false }: DrawerButtonProps) => {
  return (
    <Grid>
      <Button
        sx={{
          height: (theme) => theme.spacing(6),
          "&.Mui-disabled": {
            color: "white",
          },
        }}
        disabled={disabled}
        onClick={onClick}
        color="primary"
        variant="contained"
        fullWidth
      >
        {name}
      </Button>
    </Grid>
  );
};
export default DrawerFooterButton;
